import { useCallback, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { getAcrValues, scopes } from "@/Utils/EnvUtils";
import { migrateLegacyStorage } from "@/Utils/migrateLegacyStorage";
import { clearOtherUsersSessionStorage } from "@medoma/shared-employee/userSessionStorage";
import { Navigate, useLocation } from "react-router";

const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuth();
  const { isAuthenticated, user, events } = auth;
  const location = useLocation();

  const signin = useCallback(() => {
    void auth.signinRedirect({
      acr_values: getAcrValues(),
      scope: scopes,
      state: window.location.pathname,
    });
  }, [auth]);

  // Token can expire while the app is in background
  // Forcefully sign in again if this happens
  useEffect(() => {
    return events.addAccessTokenExpired(signin);
  }, [events, signin]);

  if (isAuthenticated && user) {
    // The gate every signed-in route passes, so storage is normalised before
    // any page reads it.
    clearOtherUsersSessionStorage(user.profile.sub);
    migrateLegacyStorage(user.profile.sub);
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default RequireAuth;
